import { v4 as uuidv4 } from "uuid"
import { db } from "../firebase/config"
import { doc, setDoc, getDoc } from "firebase/firestore"

export const getDeviceId = async () => {
  let deviceId = localStorage.getItem("deviceId")
  if (deviceId) return deviceId

  let isUnique = false

  while (!isUnique) {
    deviceId = uuidv4()

    const deviceDocRef = doc(db, "devices", deviceId)
    const docSnap = await getDoc(deviceDocRef)

    if (!docSnap.exists()) {
      isUnique = true
    }
  }

  localStorage.setItem("deviceId", deviceId)

  try {
    await setDoc(doc(db, "devices", deviceId), {
      deviceId,
      createdAt: new Date()
    })
  } catch (error) {
    console.error("Error saving deviceId to Firebase: ", error)
  }
}
